<!-- 流程委派 -->
<template>
  <j-modal centered :width="450" :ok="false" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <span slot="title">
      <span>流程委派</span>
      <span class="inlineNote" style="zoom: 1; font-size: 12px; letter-spacing: 1px"
        >（{{ form.processInstanceId }}）</span
      >
    </span>

    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="form" @keyup.enter.native="handleSubmit" :rules="rules" layout="vertical">
        <a-form-model-item prop="userIdFrom" label="原审批人" v-if="isAdmin">
          <j-dict-select-tag
            v-model="form.userIdFrom"
            :dictCode="selectUserListFrom"
            placeholder="请选择原审批人"
            type="radio"
          />
        </a-form-model-item>

        <a-form-model-item prop="userIdTo" label="委派对象">
          <j-input-popup
            v-model="selectUserListTo"
            component="SelectUserTreeModal"
            placeholder="请选择委派对象"
            :params="{
              multiFlg: '0',
              departFlg: '1',
              selectUserList: selectUserListTo,
            }"
            @change="changeSelectUserListTo"
          ></j-input-popup>
        </a-form-model-item>

        <a-form-model-item prop="comment">
          <span slot="label">
            <span>补充说明</span>
            <JSlash></JSlash>
            <span>附言</span>
          </span>

          <a-textarea
            v-model="form.comment"
            :autoSize="{ minRows: 6 }"
            placeholder="需要补充说明或附言的时候请填写"
            @keyup.enter.stop
            :maxLength="1000"
          ></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { tableMixin } from '@/mixins/tableMixin'
import { httpAction, getAction } from '@/api/manage'

class formDef {
  processInstanceId = undefined
  endDateTimestamp = undefined
  userIdFrom = undefined
  userIdTo = undefined
  comment = undefined
}

export default {
  name: 'AppointModal',
  mixins: [mixin, mixinDevice, tableMixin],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isAdmin: false,
      form: new formDef(),
      selectUserListFrom: [],
      selectUserListTo: [],
      rules: {
        userIdFrom: [this._r.required],
        userIdTo: [this._r.required],
      },
      url: {
        appoint: '/flow/processInstance/appoint',
      },
    }
  },
  methods: {
    handleOpen(record, isAdmin) {
      this.visible = true
      this.isAdmin = isAdmin
      this.form.processInstanceId = record.processInstanceId
      this.form.endDateTimestamp = record.endDateTimestamp || moment(record.endDate).format('x')

      // 管理模式打开的时候,收集当前审批人列表
      if (this.isAdmin) {
        this.selectUserListFrom = []
        if (record.lstTask.length > 0) {
          record.lstTask.forEach((task) => {
            if (task.taskActive && task.candidateUsers.length > 0) {
              task.candidateUsers.forEach((candidateUser) => {
                if (candidateUser.taskActive) {
                  if (XEUtils.filter(this.selectUserListFrom, (r) => r.value == candidateUser.id).length == 0) {
                    this.selectUserListFrom.push({
                      value: candidateUser.id,
                      text: candidateUser.realname,
                    })
                  }
                }
              })
            }
          })

          if (this.selectUserListFrom.length > 0) {
            this.form.userIdFrom = this.selectUserListFrom[0].value
          }
        }
      }
    },
    handleOk() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          // 不能委派给自己
          if (this.form.userIdTo == this.form.userIdFrom) {
            this.$message.warn('不能委派给自己')
            return
          }

          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          httpAction(this.url.appoint, this.form, 'post')
            .then((res) => {
              if (res.success) {
                this.$message.success(this.$t(res.message))
                this.$emit('emit', res.message)
                this.visible = false
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    changeSelectUserListTo(selected) {
      if (selected.length == 0) {
        this.form.userIdTo = ''
      } else {
        this.form.userIdTo = selected[0].value
      }
    },
  },
}
</script>

<style scoped></style>
